import { SenderInfoDbEntity } from "./SenderInfoDbEntity"

/**
 * WebAPI[Edit/GetEditInfo]のレスポンスのdata部
 */
export class GetEditInfoResponseEntity {

    /**
     * ログインしているか？
     */
    public isLogind: boolean;

    /**
     * 編集ID(暗号化)
     */
    public editId: string;

    /**
     * 一時編集ID(暗号化)
     */
    public tempId: string;

    /**
     * 組版トークン
     */
    public kumihanToken: string;

    /**
     * 編集開始日(暗号化)
     */
    public encCreateDate: string;

    /**
     * 組版サービスURL
     */
    public kumihanURL: string;

    /**
     * 1枚お試しフラグ
     */
    public isTrial: boolean;

    /**
     * あいさつ文のデフォルトサイズ
     */
    public greetingDefSize: GreetingDefSize;

    /**
     * マスタ情報
     * スタンプマスタ・既製あいさつ文・半既製あいさつ文・カラー・はがき・フォント
     */
    public master: GetEditInfoMasterEntity;

    /**
     * 編集データに関連する情報
     * スタンプマスタ・既製あいさつ文・半既製あいさつ文・カラー・はがき・フォント
     */
    public info: GetEditInfoTranEntity;
}

/**
 * マスタ情報
 */
export class GetEditInfoMasterEntity {

    /**
     * スタンプマスタ
     */
    public stamp: GetEditInfoStampCategoryEntity[];

    /**
     * スタンプカテゴリ
     */
    public stampCategory: string[];

    /**
     * あいさつ文マスタ
     */
    public greeting: GetEditInfoGreetingEntity[];

    /**
     * カラーマスタ
     */
    public color: GetEditInfoColorEntity[];

    /**
     * はがきマスタ
     */
    public hagaki: GetEditInfoHagakiEntity[];

    /**
     * フォントマスタ
     */
    public font: GetEditInfoFontEntity[];

    /**
     * デザインマスタ
     */
    public design: GetEditInfoDesignEntity;

    /**
     * 外字リスト
     */
    public gaijiList: GetEditInfoGaijiEntity[];
}

/**
 * スタンプカテゴリ
 */
export class GetEditInfoStampCategoryEntity {
    /**
     * カテゴリインデックス
     */
    public id: number;

    /**
     * カテゴリ名称
     */
    public category: string;

    /**
     * 幅
     */
    public width: number;

    /**
     * 高さ
     */
    public height: number;

    /**
     * サムネイルパス
     */
    public url: string;

    /**
     * 表示順
     */
    public seq: number;

    /**
     * ファイル名(暗号化)
     */
    public name: string;
}

/**
 * あいさつ文
 */
export class GetEditInfoGreetingEntity {

    /**
     * インデックス
     */
    public id: number;

    /**
     * 文章番号
     */
    public no: string;

    /**
     * テキスト
     */
    public text: string;

    /**
     * サムネイルパス
     */
    public url: string;


    /**
     * 以降はフロント側で使用するための拡張項目
     */
    public selected: boolean;

}

/**
 * カラー定義
 */
export class GetEditInfoColorEntity {

    /**
     * インデックス
     */
    public id: string;

    /**
     * 色名称
     */
    public name: string;

    /**
     * rgb
     */
    public rgb: string;

    /**
     * cmyk
     */
    public cmyk: string;
}

/**
 * はがき定義
 */
export class GetEditInfoHagakiEntity {

    /**
     * インデックス
     */
    public id: string;

    /**
     * 表示名
     */
    public name: string;

    /**
     * サムネイルパス
     */
    public url: string;

    /**
     * 表示順
     */
    public seq: number;
}

/**
 * フォント
 */
export class GetEditInfoFontEntity {

    /**
     * インデックス
     */
    public id: string;

    /**
     * 画面表示用のフォント名
     */
    public name: string;

    /**
     * フォント番号
     */
    public no: string;

    /**
     * 組版用のフォント名
     */
    public actualName: string;

    /**
     * サムネイルパス
     */
    public url: string;

    /**
     * 表示順
     */
    public seq: number;

    /**
     * 外字表示フラグ
     */
    public gaijiFlg: boolean;
}

/**
 * デザイン定義
 */
export class GetEditInfoDesignEntity {

    /**
     * デザイン番号
     */
    public dsnNo: string;

    /**
     * デフォルトフォント
     */
    public fontType: string;

    /**
     * デザイン区分
     */
    public dsnType: string;

    /**
     * キャラクター区分
     */
    public charaType: string;

    /**
     * 文字色インデックス
     */
    public fontColor: string;

    /**
     * あいさつ文デフォルト値
     */
    public greeting: DesignDetailEntity;

    /**
     * 差出人デフォルト値
     */
    public sender: DesignDetailEntity;

    /**
     * 機能制限フラグ(0:制限なし, 1:画像補正・あいさつ文・スタンプを制限)
     */
    public editMode: string;

    /**
     * テンプレートの有効期限ないか？
     */
    public isExpire: boolean;

    /**
     * 出力タイプ(1:印刷, 2:銀塩, 0:印刷／銀塩)
     */
    public printType: string;

    /**
     * 注文停止期間チェック
     */
    public orderStop: string;

    /**
     * デフォルト出力タイプ(1:印刷, 2:銀塩)
     */
    public defPrintType: string;

}

/**
 * デザイン詳細定義
 */
export class DesignDetailEntity {

    /**
     * 番号
     */
    public no: string;

    /**
     * 組方向(縦0、横1)
     */
    public direction: string;

    /**
     * x座標(左下原点、単位mm)
     */
    public x: number;

    /**
     * y座標
     */
    public y: number;

    /**
     * 幅
     */
    public width: number;

    /**
     * 高さ
     */
    public height: number;

    /**
     * 回転角度
     */
    public rotate: number;

    /**
     * 配置位置
     */
    public align: string;

}

/**
 * 編集データに関連するトランザクション情報
 */
export class GetEditInfoTranEntity {

    /**
     * 使用中のスタンプIDの一覧
     */
    public stamp: GetEditInfoStampEntity[];

    /**
     * 写真情報の一覧
     */
    public photo: GetEditInfoPhotoEntity[];

    /**
     * 枠情報の一覧
     */
    public photoUse: GetEditInfoPhotoUseEntity[];

    /**
     * 差出人情報
     */
    public sender: GetEditInfoSenderEntity;

    /**
     * あいさつ文情報
     */
    public greeting: GetEditInfoGreetingTranEntity[];

    /**
     * 印刷タイプ
     */
    public printType: string;

    /**
     * 編集データ有効期限チェック
     */
    public isExpire: boolean;

    /**
     * ハガキ種
     */
    public postcardType: number;

    /**
     * 注文枚数
     */
    public orderNum: number;

    /**
     * 保存名称
     */
    public saveAs: string;

    /**
     * Myステッカー情報の一覧
     */
    public myStamp: GetEditInfoPhotoEntity[];

    /**
     * Myステッカー配置情報の一覧
     */
    public myStampUse: GetEditInfoPhotoUseEntity[];

    /**
     * 手書きスタンプ情報の一覧
     */
    public fontgenic: GetEditInfoPhotoEntity[];

    /**
     * フォントジェニック配置情報の一覧
     */
    public fontgenicUse: GetEditInfoFontgenicUseEntity[]
}

/**
 * スタンプに関連するトランザクション情報
 */
export class GetEditInfoStampEntity {

    /**
     * アイテム番号
     */
    public idx: number;

    /**
     * スタンプID
     */
    public stampId: string;

    /**
     * Sonbpのベンダープロパティ
     */
    public sonbpVp: SonbpVp;

    /**
     * アイテム番号をstring型で取得
     */
    public get IdxToString(): string {
        return this.idx.toString(10);
    }


}


/**
 * 写真に関連するトランザクション情報
 */
export class GetEditInfoPhotoEntity {

    /**
     * ファイルID
     */
    public fileId: string;

    /**
     * 使用中かどうか
     */
    public isUsed: boolean;

    /**
     * 実サイズ(px) 幅
     */
    public width: number;

    /**
     * 実サイズ(px) 高さ
     */
    public height: number;

    /**
     * ファイル名（オリジナル）
     */
    public uploadFileName: string;

    /**
     * アップロード日時
     */
    public uploadDate: Date;

}

/**
 * 画像枠に関連するトランザクション情報
 */
export class GetEditInfoPhotoUseEntity {

    /**
     * ファイルID
     */
    public fileId: string;

    /**
     * 枠番号
     */
    public idx: number;

    /**
     * I2補正する
     */
    public isUseI2: boolean;

    /**
     * 明るさ
     */
    public brightId: number;

    /**
     * Sonbpのベンダープロパティ
    */
    public sonbpVp: SonbpVp;

}

/**
 * 画像枠に関連するトランザクション情報
 */
export class GetEditInfoFontgenicUseEntity {

    /**
     * ファイルID
     */
    public fileId: string;

    /**
     * 枠番号
     */
    public idx: number;

    /**
     * 色ID
     */
    public colorId: string;

    /**
     * Sonbpのベンダープロパティ
    */
    public sonbpVp: SonbpVp;
}


/**
 * 手書きスタンプ配置に関連するトランザクション情報
 */
export class GetEditInfoTegakiStampUseEntity {

    /**
     * ファイルID
     */
    public fileId: string;

    /**
     * 色番号
     */
    public colorId: boolean;

    /**
     * 枠番号
     */
    public idx: number;

    /**
     * Sonbpのベンダープロパティ
    */
    public sonbpVp: SonbpVp;

}


/**
 * 差出人に関連するトランザクション情報
 */
export class GetEditInfoSenderEntity {

    /**
     * 名入れタイプ
     */
    public type: string;

    /**
     * フォント名
     */
    public font: string;

    /**
     * フォントサイズ
     */
    public size: number;

    /**
     * X座標
     */
    public x: number;

    /**
     * Y座標
     */
    public y: number;

    /**
     * 回転角度
     */
    public rotate: number;

    /**
     * color(CMYK)
     */
    public color: string;

    /**
     * フチ文字のcolor(CMYK)
     */
    public outlineColor: string;

    /**
     * 行揃え
     */
    public align: string;

    /**
     * 組方向
     */
    public direction: string;

    /**
     * 組版レイアウト
     */
    public layout: string;

    /**
     * 差出人情報テーブル
     */
    public senderInfo: SenderInfoDbEntity;

}

/**
 * あいさつ文に関連するトランザクション情報
 */
export class GetEditInfoGreetingTranEntity {

    /**
     * インデックス
     */
    public id: string;

    /**
     * 文章番号
     */
    public greetingNo: string;

    /**
     * フォント名
     */
    public font: string;

    /**
     * フォントサイズ
     */
    public size: number;

    /**
     * color(CMYK)
     */
    public color: string;

    /**
     * フチ文字のcolor(CMYK)
     */
    public outlineColor: string;

    /**
     * 行揃え
     */
    public align: string;

    /**
     * あいさつ文テキスト
     */
    public text: string;

    /**
     * 組方向
     */
    public direction: string;

    /**
     * 喪中に関する情報
     */
    public mocyu: GetEditInfoGreetingMocyuEntity[];

    /**
     * 差出月
     */
    public mocyuSend: string;

    /**
     * Sonbpのベンダープロパティ
     */
    public sonbpVp: SonbpVp;

}

/**
 * あいさつ文(喪中)情報
 */
export class GetEditInfoGreetingMocyuEntity {

    public month: string;
    public day: string;
    public age: string;
    public relative: string;
    public name: string;
}

/**
 * sonbpのベンダープロパティ
 * */
export class SonbpVp {
    public idx: number;
    public x: number;
    public y: number;
    public width: number;
    public height: number;
    public angle: number;
}

/**
 * 画像存在チェック情報
 */
export class GetEditInfoCheckUploadImagesEntity {
    public photo: boolean;
    public mystamp: boolean;
    public fontgenic: boolean;
}

/**
 * 外字リストエンティティ
 * */
export class GetEditInfoGaijiEntity {
    /**
     * 外字の読み
     */
    public yomi: string;
    /**
     * 外字
     */
    public character: string;
}

export class ChangeBright {
    public fileId: string;
}


/**
 * あいさつ文のデフォルトサイズ
 * */
export class GreetingDefSize {
    public longSide: number;
    public shortSide: number;
}